export default __webpack_public_path__ + "static/media/store.e5f360f0.svg";